module.exports = __webpack_public_path__ + "img/full-speech_bubble1.5d1cd80f.png";